import { AxiosInstance } from 'axios';

import { ExtendedApiModelClient, BaseAuthenticatedClient } from '.';
import { BaseDataResponse, BasePageDataResponse, BaseResponse } from '../responses';
import { AccommodatedGuestModel, BaseModel, VirtualModel } from '../interfaces';
import { IAuthenticatedRequestHandler, IErrorHandler } from '../abstractions';

export default class AccommodatedGuestsClient extends BaseAuthenticatedClient implements ExtendedApiModelClient<AccommodatedGuestModel> {
  constructor(authenticatedRequestHandler: IAuthenticatedRequestHandler, errorHandler: IErrorHandler, axiosInstance: AxiosInstance) {
    super(authenticatedRequestHandler, errorHandler, axiosInstance, 'accommodatedguests');
  }
  
  getByVirtualPageAsync(page: number, search: string, id: number, filter: string): Promise<BasePageDataResponse<VirtualModel[]>> {
    throw new Error('Method not implemented.');
  }
  
  getAsync(id: number): Promise<BaseDataResponse<AccommodatedGuestModel>> {
    throw new Error('Method not implemented.');
  }
  
  updateAsync(model: BaseModel): Promise<BaseDataResponse<AccommodatedGuestModel>> {
    throw new Error('Method not implemented.');
  }

  createAsync(model: BaseModel): Promise<BaseDataResponse<AccommodatedGuestModel>> {
    throw new Error('Method not implemented.');
  }

  deleteAsync(id: number): Promise<BaseResponse> {
    throw new Error('Method not implemented.');
  }

  public async getByPageAsync(skip: number, take: number, filter: string): Promise<BasePageDataResponse<AccommodatedGuestModel[]>> {
    return await this.getHttpAsync<BasePageDataResponse<AccommodatedGuestModel[]>>(``, `skip=${skip}&take=${take}&filter=${filter}`);
  }

  public async getAllAsync(): Promise<BaseDataResponse<AccommodatedGuestModel[]>> {
    return await this.getHttpAsync<BaseDataResponse<AccommodatedGuestModel[]>>('', '');
  }
}